import AgoraRTC from "agora-rtc-sdk-ng"

const AGORA_APP_ID = import.meta.env.VITE_AGORA_APP_ID
const TOKEN_SERVER_URL = import.meta.env.VITE_AGORA_TOKEN_URL // e.g. https://nesolearn-backend.onrender.com

export async function fetchAgoraToken(channel, uid, role) {
  const baseUrl = TOKEN_SERVER_URL?.replace(/\/+$/, "") // strip any trailing slash(es)
  const url = `${baseUrl}/agora/token?channel=${channel}&uid=${uid}&role=${role}`
  const res = await fetch(url)
  if (!res.ok) throw new Error("Failed to fetch Agora token")
  const { token } = await res.json()
  return token
}

export function createAgoraClient() {
  return AgoraRTC.createClient({ mode: "live", codec: "vp8" })
}

// role: "broadcaster" (instructor) or "audience" (learner)
export async function joinChannel(client, channel, uid, role) {
  await client.setClientRole(role === "broadcaster" ? "host" : "audience")
  const token = await fetchAgoraToken(channel, uid, role)
  await client.join(AGORA_APP_ID, channel, token, uid)
}

export async function createLocalTracks() {
  const [audioTrack, videoTrack] = await AgoraRTC.createMicrophoneAndCameraTracks()
  return { audioTrack, videoTrack }
}

export async function leaveChannel(client, localTracks) {
  localTracks?.audioTrack?.close()
  localTracks?.videoTrack?.close()
  await client?.leave()
}